import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import createRoutes  from './router';

// const refreshCacheAndReload = () =>{
//   if (caches) {
//   caches.keys().then(async function(names) {
//   await Promise.all(names.map(name => caches.delete(name)))
//   })
//   }
  // console.log("working");
  // //window.location.reload(true);
  // }

//refreshCacheAndReload(); 
const routes = App();
ReactDOM.render(
  routes,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
